<template>
    <div class="notification" :class="notification.type ? notification.type : 'secondary'" @click="close()">

        <h5 v-if="notification.title">{{notification.title}}</h5>
        <p v-if="!isArray">{{notification.text}}</p>
        <ul v-if="isArray">
            <li v-for="content in notification.text">{{ content }}</li>
        </ul>

    </div>
</template>


<script>

export default {
    props: [ 'notification' ],
    mounted: function () {
        if (typeof this.notification.timeout === 'number' && this.notification.timeout > 0) {
            setTimeout(this.close, this.notification.timeout)
        }
    },
    computed: {
        isArray: function() {
            return this.notification.text instanceof Array
        }
    },
    methods: {
        close: function() {
            this.$emit('close-notification', this.notification)
        }
    }
}
</script>


<style lang="scss">

    @import 'global';

    .notification {
        $color: map-get($notification-types, 'info');
        background-color: $color;
        border: 1px solid darken($color, 30%);
        color: $color-typography-inverted;
        border-radius: 4px;
        padding: 1em;
        margin: 0 0 1em; // margin top moves the notification for position: absolute
        width: 100%; // needed for position: absolute in animation

        h5, p {
            margin: 0;
        }

        @each $type, $color in $notification-types {
            &.#{$type} {
                background-color: $color;
                border-color: darken($color, 30%);
            }
        }

    }

</style>



// WEBPACK FOOTER //
// Notification.vue?99b7faf8